import React, { Component } from "react";
import Header from "../header";

class AboutUs extends Component {
  render() {
    return (
      <div className="showMore-rules">
        <Header showSearchBar={true} title={"درباره ما | کاچار"} />
        <iframe
          src="https://kacharlife.com/aboutus"
          seamless
          style={{ border: "none", height: "88vh", width: "100vw" }}
          allow="fullscreen"
          title="kacharlife"
        />
      </div>
    );
  }
}
export default AboutUs;
